import { footerColumns, siteMeta } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-accent-100 text-foreground-900">
      <div className="mx-auto w-full max-w-[1180px] px-4 pb-8 pt-12 md:px-6 md:pt-14">
        <div className="grid grid-cols-1 gap-8 border-b border-accent-300 pb-9 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">
              {siteMeta.name}
              <span className="text-primary-600">.</span>
            </span>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-foreground-700 md:text-sm">
              黑料91深扒栏目把人物和事件背后的线索逐条排列，配合背景、时间线和各方反应互相对照，帮助读者看清隐藏关系、补全来龙去脉。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="rounded-md border border-accent-300 bg-accent-50 px-2.5 py-1 text-[11px] text-foreground-700">
                {siteMeta.issue}
              </span>
              <span className="rounded-md border border-accent-300 bg-accent-50 px-2.5 py-1 text-[11px] text-foreground-700">
                {siteMeta.date}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h3 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h3>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="cursor-pointer text-xs text-foreground-700 transition-colors hover:text-primary-700"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6 text-[11px] text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 {siteMeta.name} · 深扒组 内容整理</span>
          <span className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              回到顶部
            </a>
            <span className="hidden h-3 w-px bg-accent-300 sm:block" />
            <span>本站记录均来自公开渠道，仅作线索对照。</span>
          </span>
        </div>
      </div>
    </footer>
  );
}